import 'isomorphic-fetch';

import React from 'react';

import { setGlobalNotification, refreshPage, getFetchConfig } from 'Actions/GlobalMetaActions';
import { showGlobalLoading, hideGlobalLoading, displayNotification, showConfirmModal } from 'Actions/UiActions'
import { trackGAEvent } from 'Actions/adsActions';

/**
 * openCloseThread
 *
 * @param threadId
 * @param actionState bool true: open | false: close
 * @returns {Function}
 */
export function openCloseThread( threadId, actionState = false ) {
	return function(dispatch, getState) {
		if( !threadId ) {
			topifyConsole.warn( ( actionState ? 'Open' : 'Close' ) + ' Thread - thread id not provided', threadId );
			return;
		}
		topifyConsole.log( actionState, ( actionState ? 'Open' : 'Close' ) + ' Thread', threadId );

		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			userID = state.ustate.id ? state.ustate.id : 0,
			newState =  actionState ? 1 : 0;

		let moreData = `type=openclose&action=openclose&threadid=${ threadId }&state=${ newState }`;

		const fetchConfig = dispatch( getFetchConfig( true, 'POST', moreData ) );

		dispatch( showGlobalLoading( 'Processing' ) );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=post`, fetchConfig )
			.then((response) => {
					if (!response.ok) {
						try {
							response.json().then((json) => {
								setGlobalNotification( dispatch, json, response );
							});
						} catch( e ) {
							setGlobalNotification( dispatch, {}, response );
						}

					} else {
						response.json()
							.then((json) => {
									if( json.state ) {
										setGlobalNotification( dispatch, json, { ok: true } );

										// Record the Google Analytics event.
										dispatch( trackGAEvent( false, ( json.result.isOpen ? 'modOpenTopic' : 'modCloseTopic' ), 'moderatorAction', 'topic' ) );

										let message = `This Topic is ${ json.result.isOpen ? 'open' : 'closed' }`,
											notificationType = 'success';
										if( json.result.isOpen !== actionState ) {
											message = `Something went wrong, the Topic didn't change its state.${ message }`;
											notificationType = 'warning';
										}
										displayNotification( notificationType, message );
									} else {
										displayNotification( 'warning', 'Some error happened. Try again.' );
									}
								}
							)
					}
				}
			).then(()=>{
				dispatch( refreshPage() );
				dispatch( hideGlobalLoading() );

			}).catch( (error) => {
				dispatch( hideGlobalLoading() );
				setGlobalNotification(dispatch,{},error);
				dispatch( refreshPage() );
			});
	};
}

/**
 * deleteRestoreThread
 *
 * @param threadId
 * @param actionState bool true: restore | false: delete
 * @returns {Function}
 */
export function deleteRestoreThread( threadId, actionState = false ) {
	return function(dispatch, getState) {
		if( !threadId ) {
			topifyConsole.warn( ( actionState ? 'Restore' : 'Delete' ) + ' Thread - thread id not provided', threadId );
			return;
		}
		topifyConsole.log( actionState, ( actionState ? 'Restore' : 'Delete' ) + ' Thread', threadId );

		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			userID = state.ustate.id ? state.ustate.id : 0,
			newState =  actionState ? 1 : 0;

		let moreData = `type=deletethread&action=delete&threadid=${ threadId }&state=${ newState }`;

		const fetchConfig = dispatch( getFetchConfig( true, 'POST', moreData ) );

		dispatch( showGlobalLoading( 'Processing' ) );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=post`, fetchConfig )
			.then((response) => {
					if (!response.ok) {
						try {
							response.json().then((json) => {
								setGlobalNotification( dispatch, json, response );
							});
						} catch( e ) {
							setGlobalNotification( dispatch, {}, response );
						}

					} else {
						response.json()
							.then((json) => {
									if( json.state ) {
										setGlobalNotification( dispatch, json, { ok: true } );

										// Record the Google Analytics event.
										dispatch( trackGAEvent( false, ( json.result.isDeleted ? 'modDeleteTopic' : 'modRestoreTopic' ), 'moderatorAction', 'topic' ) );

										let message = `You have ${ json.result.isDeleted ? 'deleted' : 'restored' } this topic`,
											notificationType = 'success';
										if( json.result.isDeleted === actionState ) {
											message = `Something went wrong, the Topic didn't change its state.`;
											notificationType = 'warning';
										}
										displayNotification( notificationType, message );
									} else {
										displayNotification( 'warning', 'Some error happened. Try again.' );
									}
								}
							)
					}
				}
			).then(()=>{
				dispatch( refreshPage() );
				dispatch( hideGlobalLoading() );

			}).catch( (error) => {
				dispatch( hideGlobalLoading() );
				setGlobalNotification(dispatch,{},error);
				dispatch( refreshPage() );
			});
	};
}

/**
 * Lifts ban on user
 *
 * @param banneduserId
 * @returns {Function}
 */
export function liftUserBan( banneduserId ) {
	return function(dispatch, getState) {
		if( !banneduserId ) {
			topifyConsole.warn( 'Lift user ban - User id not provided', banneduserId );
			return;
		}
		topifyConsole.log( 'Lift user ban', banneduserId );

		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			userID = state.ustate.id ? state.ustate.id : 0;

		let moreData = `type=moderate_user&action=unban&userid=${ banneduserId }`;

		const fetchConfig = dispatch( getFetchConfig( true, 'POST', moreData ) );

		dispatch( showGlobalLoading( 'Processing' ) );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=post`, fetchConfig )
			.then((response) => {
					if (!response.ok) {
						try {
							response.json().then((json) => {
								setGlobalNotification( dispatch, json, response );
							});
						} catch( e ) {
							setGlobalNotification( dispatch, {}, response );
						}

					} else {
						response.json()
							.then((json) => {
									if( json.state ) {
										setGlobalNotification( dispatch, json, { ok: true } );
										let message = `Ban on user "${ json.result.username }" has been lifted`,
											notificationType = 'success';
										displayNotification( notificationType, message );
									} else {
										displayNotification( 'warning', 'Some error happened. Try again.' );
									}
								}
							)
					}
				}
			).then(()=>{
				dispatch( refreshPage() );
				dispatch( hideGlobalLoading() );

			}).catch( (error) => {
				dispatch( hideGlobalLoading() );
				setGlobalNotification(dispatch,{},error);
				dispatch( refreshPage() );
			});
	};
}

/**
 * Request Ban confirmation to the site
 *
 * @param banneduserId
 * @param type
 * @param renderConfirm
 * @returns {Function}
 */
export function banUser_confirm( banneduserId, type, renderConfirm ) {
	return function(dispatch, getState) {
		if( !banneduserId ) {
			topifyConsole.warn( 'Ban user - User id not provided', banneduserId );
			return;
		}
		topifyConsole.log( 'Ban user', banneduserId );

		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			userID = state.ustate.id ? state.ustate.id : 0,
			ban_type = `${ type }ban_confirm`;

		let moreData = `type=moderate_user&action=${ ban_type }&req=post&userid=${ banneduserId }`;

		const fetchConfig = dispatch( getFetchConfig( true, 'POST', moreData ) );

		dispatch( showGlobalLoading( 'Processing' ) );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=post`, fetchConfig )
			.then( (response) => {
					if( !response.ok ) {
						try {
							response.json().then((json) => {
								setGlobalNotification( dispatch, json, response );
							});
						} catch( e ) {
							setGlobalNotification( dispatch, {}, response );
						}
						dispatch( refreshPage() );

					} else {
						response.json()
							.then( ( json ) => {
								if( json.result.username && json.result.userid ) {
									let title = "Ban User Confirmation",
										content = renderConfirm( type, json.result );
									let props = { type: type, userid: json.result.userid };
									dispatch( showConfirmModal( title, content, () => sendBanConfirmation( props, dispatch ) ) );
								}
							} );
					}
				}
			).then( () => {
				dispatch( hideGlobalLoading() );

			}).catch( (error) => {
				dispatch( hideGlobalLoading() );
				setGlobalNotification(dispatch,{},error);
				dispatch( refreshPage() );
			});
	};
}

/**
 * Sends data to Ban User
 *
 * @param banneduserId
 * @param type
 * @param data
 * @returns {Function}
 */
export function banUser( banneduserId, type, data ) {
	return function(dispatch, getState) {
		if( !banneduserId ) {
			topifyConsole.warn( 'Ban user - User id not provided', banneduserId );
			return;
		}
		topifyConsole.log( 'Ban user', banneduserId, type, data );

		const state = getState(),
			url = state.topifyPresets.forumSite.url,
			userID = state.ustate.id ? state.ustate.id : 0,
			ban_type = `${ type }ban`;

		let moreData = `type=moderate_user&action=${ ban_type }&req=post&userid=${ banneduserId }`;
		for( let field in data ) {
			if( data.hasOwnProperty( field ) ) {
				moreData += `&${ field }=${ encodeURIComponent( data[ field ] ) }`;
			}
		}

		const fetchConfig = dispatch( getFetchConfig( true, 'POST', moreData ) );

		dispatch( showGlobalLoading( 'Processing' ) );

		return fetch( url + `?v=3.0&ajax=1&uid=${ userID }&req=post`, fetchConfig )
			.then((response) => {
					if (!response.ok) {
						try {
							response.json().then((json) => {
								setGlobalNotification( dispatch, json, response );
							});
						} catch( e ) {
							setGlobalNotification( dispatch, {}, response );
						}

					} else {
						response.json()
							.then((json) => {
									if( json.result && json.result.username && json.result.userid ) {
										setGlobalNotification( dispatch, json, { ok: true } );
										let message = json.result.message.text ?
												<span>Result: { json.result.message.text }</span> :
												`User "${ json.result.username }" has been banned ${ json.result.message.lift ? 'until ' + json.result.message.lift : 'permanently' }`,
											notificationType = 'success';
										displayNotification( notificationType, message );
									} else {
										displayNotification( 'warning', 'Some error happened. Try again.' );
									}
								}
							)
					}
				}
			).then(()=>{
				dispatch( refreshPage() );
				dispatch( hideGlobalLoading() );

			}).catch( (error) => {
				dispatch( hideGlobalLoading() );
				setGlobalNotification(dispatch,{},error);
				dispatch( refreshPage() );
			});
	};
}

/**
 * Verifies form, get form data and dispatch sending the data
 * @param props
 * @param dispatch
 * @returns {boolean}
 */
function sendBanConfirmation( props, dispatch ) {
	let error = false,
		data = {},
		form = document.getElementsByClassName( 'banUserForm' );
	form = form && form.length > 0 ? form[ 0 ] : null;

	if( form ) {
		let selectFields = form.getElementsByTagName( 'select' ),
			inputFields = form.getElementsByTagName( 'input' );

		// selectFields is a HTMLCollection, we convert it to an array to allow map
		[].slice.call( selectFields ).map( ( el ) => {
			if( el.name && el.value ) {
				data[ el.name ] = el.value;
			}
		} );
		// inputFields is a HTMLCollection, we convert it to an array to allow map
		[].slice.call( inputFields ).map( ( el ) => {
			if( el.name ) {
				if( el.required && !el.value ) {
					displayNotification( 'warning', 'Please fill mandatory fields.' );
					el.parentNode.classList.add( 'required-incomplete' );
					error = true;
				} else {
					data[ el.name ] = el.value;
				}
			}
		} );

		if( error ) {
			return false;
		} else {
			dispatch( showGlobalLoading( 'Processing' ) );
			dispatch( trackGAEvent( false, `modBanUser_${ props.type ? props.type : 'simple' }`, 'moderatorAction', 'banUser' ) );
			dispatch( banUser( props.userid, props.type, data ) );
			return true;
		}
	}
	return false;
}



// WEBPACK FOOTER //
// ./src/actions/ModToolsActions.js